export const SICK_LEAVE_REASON = {
  SICK: "sick"
};

export const GENERAL_LEAVE_REASONS = {
  FAMILY_EMERGENCY: "family_emergency",
  PERSONAL: "personal",
  MEDICAL_APPOINTMENT: "medical_appointment",
  BEREAVEMENT: "bereavement",
  OTHER: "other"
};

export const GENERAL_LEAVE_REASONS_LABELS = {
  [GENERAL_LEAVE_REASONS.FAMILY_EMERGENCY]: "Family Emergency",
  [GENERAL_LEAVE_REASONS.PERSONAL]: "Personal",
  [GENERAL_LEAVE_REASONS.MEDICAL_APPOINTMENT]: "Medical Appointment",
  [GENERAL_LEAVE_REASONS.BEREAVEMENT]: "Bereavement",
  [GENERAL_LEAVE_REASONS.OTHER]: "Other"
};

export const LEAVE_REASONS = {
  SICK: "sick",
  FAMILY_EMERGENCY: "family_emergency",
  PERSONAL: "personal",
  MEDICAL_APPOINTMENT: "medical_appointment",
  BEREAVEMENT: "bereavement",
  OTHER: "other"
};

export const LEAVE_REASONS_LABELS = {
  [LEAVE_REASONS.SICK]: "Sick",
  [LEAVE_REASONS.FAMILY_EMERGENCY]: "Family Emergency",
  [LEAVE_REASONS.PERSONAL]: "Personal",
  [LEAVE_REASONS.MEDICAL_APPOINTMENT]: "Medical Appointment",
  [LEAVE_REASONS.BEREAVEMENT]: "Bereavement",
  [LEAVE_REASONS.OTHER]: "Other"
};

export const LEAVE_TYPE = {
  SICK: "sick",
  GENERAL: "general"
};

export const ADMIN_LEAVE_FILTER_ALL = "all";

export const SICKNESS_MARK_TYPE = {
  NORMAL: "normal",
  LATE: "late"
};

export const SICKNESS_MARK_TYPE_LABELS = {
  [SICKNESS_MARK_TYPE.NORMAL]: "Normal",
  [SICKNESS_MARK_TYPE.LATE]: "Late"
};

export const LEAVE_TYPE_LABELS = {
  [LEAVE_TYPE.SICK]: "Sick",
  [LEAVE_TYPE.GENERAL]: "General"
};

export const LEAVE_STATUS = {
  PENDING: "pending",
  APPROVED: "approved",
  REJECTED: "rejected",
  EVIDENCE_PENDING: "evidence_pending"
};

export const LEAVE_STATUS_LABELS = {
  [LEAVE_STATUS.PENDING]: "Pending",
  [LEAVE_STATUS.APPROVED]: "Approved",
  [LEAVE_STATUS.REJECTED]: "Rejected",
  [LEAVE_STATUS.EVIDENCE_PENDING]: "Evidence Pending"
};

export const FIT_NOTE_STATUS = {
  PENDING: "pending",
  ACTIVE: "active",
  EXPIRED: "expired"
};

export const FIT_NOTE_STATUS_LABELS = {
  [FIT_NOTE_STATUS.PENDING]: "Pending",
  [FIT_NOTE_STATUS.ACTIVE]: "Active",
  [FIT_NOTE_STATUS.EXPIRED]: "Expired"
};

export const ADMIN_FIT_NOTE_REJECTION_STATUS = {
  MISSING: "missing",
  EXPIRED: "expired"
};

export const ADMIN_FIT_NOTE_REJECTION_STATUS_LABELS = {
  [ADMIN_FIT_NOTE_REJECTION_STATUS.MISSING]: "Missing",
  [ADMIN_FIT_NOTE_REJECTION_STATUS.EXPIRED]: "Expired"
};

export const SICK_LEAVE_AUTO_APPROVE_STREAK_LIMIT = 7;
export const SICK_LEAVE_REQUEST_WINDOW_HOURS = 12;
export const SICK_LEAVE_REQUEST_CUTOFF_MINUTES = 5;
